'use client';

import { type FC, useState } from 'react';
import type { StepProps } from '@/lib/flow/types';
import type { PersonalDataAction } from './actions';
import { OverviewForm } from './overview-form';
import { PersonalDataForm } from './personal-data-form';
import type { OverviewState } from './schema';

type FormWrapperProps = Pick<StepProps<OverviewState>, 'action' | 'completionPath' | 'state' | 'stepId'> & {
  updatePersonalDataAction: PersonalDataAction;
  privacyNoticeText: React.ReactNode;
  leadConsentText: React.ReactNode;
  marketingConsentText: React.ReactNode;
};

export const FormWrapper: FC<FormWrapperProps> = ({
  action,
  completionPath,
  updatePersonalDataAction,
  stepId,
  state,
  privacyNoticeText,
  leadConsentText,
  marketingConsentText,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [submitAttempted, setSubmitAttempted] = useState(false);

  return (
    <>
      <PersonalDataForm
        action={updatePersonalDataAction}
        state={state}
        setIsEditing={(isEditing: boolean) => {
          setSubmitAttempted(!isEditing);
          setIsEditing(isEditing);
        }}
        isEditing={isEditing}
        editingNotFinishedError={submitAttempted && isEditing}
      />

      <OverviewForm
        action={action}
        completionPath={completionPath}
        stepId={stepId}
        state={state}
        isPersonalDataFormEditing={isEditing}
        onSubmitAttempt={() => setSubmitAttempted(true)}
        leadConsentText={leadConsentText}
        marketingConsentText={marketingConsentText}
        privacyNoticeText={privacyNoticeText}
      />
    </>
  );
};
